import moment from 'moment';
<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="orders"
          title="Orders"
          :icon="orderIcon"
          align-top>
    <div class="heading">
      <span>{{ header }}</span>
      <span class="subtitle">{{ subHeader }}</span>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import axios from 'axios';
  import moment from 'moment';

  // DEAN COMPONENTS
  import {
    plusIcon,
    orderIcon,
    dashboardIcon,
    deanDialog,
    deanButton,
    deanLoadOverlay,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanLoadOverlay,
      plusIcon,
      orderIcon,
      dashboardIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class MonthlyOrders extends Vue {
    public plusIcon: object = plusIcon;
    public orderIcon: object = orderIcon;
    public header: string = '';
    public subHeader: string = '';
    public isLoading: boolean = true;

    public mounted() {
      axios
        .post('/-/trade/api/widgets.monthlyOrdersTotal')
        .then(({data}) => {
          this.header = data.monthlyOrders;
          this.subHeader = `Orders ${moment().format('MMM')}`;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-content) .dean-dialog-title {
    color: white;
    fill: white;
  }

  .dialog :deep(.dean-dialog-container) .dean-dialog-content {
    height: 100%;
    background-color: var(--color-primary, $color-primary);
  }

  .orders .heading {
    color: #FFF;
    margin-top: 1.6rem;
    font-weight: bold;
    font-size: 2.4rem;
    padding: 10px;

    span {
      display: block;
    }

    .subtitle {
      font-size: 1.5rem;
      font-weight: normal;
    }
  }
</style>
